import { Button } from "@kaltura/ds-react-components";
import { Add24Icon } from "@kaltura/ds-react-icons";
import { translate } from "@kaltura/ds-react-utils";
import { CreateCategoryModal } from "@kaltura/mediaspace-shared-create-category-modal";
import { useState } from "react";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";
import { useChannelsContext } from "../ChannelsContext";
import styled from "@emotion/styled";
import { baseUrl } from "@kaltura/mediaspace-shared-utils";

interface CreateChannelButtonProps {
    borderless?: boolean;
}

const StyledButton = styled(Button)(({ theme }) => ({
    flexShrink: 0,
}));

const CreateChannelButton = (props: CreateChannelButtonProps) => {
    const { borderless = false } = props;

    const [modalOpen, setModalOpen] = useState(false);

    const sendButtonAnalytics = useButtonAnalytics();

    const { createChannelModalProps } = useChannelsContext();

    const handleClick = () => {
        sendButtonAnalytics("Create Channel - DS", ButtonClickAnalyticsType.CREATE);
        setModalOpen(true);
    };

    return (
        <>
            <StyledButton
                className={"kms-ds-create-channel-button"}
                startIcon={<Add24Icon />}
                variant={borderless ? "borderless" : "pill"}
                color={borderless ? "secondary" : "primary"}
                onClick={createChannelModalProps ? handleClick : undefined}
                href={createChannelModalProps ? undefined : `${baseUrl}/channels/create`}
            >
                {translate("Create channel")}
            </StyledButton>

            {createChannelModalProps !== undefined && (
                <CreateCategoryModal
                    open={modalOpen}
                    onCancel={() => setModalOpen(false)}
                    {...createChannelModalProps}
                />
            )}
        </>
    );
};

export default CreateChannelButton;
